import { useEffect } from "react";
import { useAppBootstrap } from "../providers/AppBootstrapProvider";
import { useAccountReadiness } from "../providers/AccountReadinessProvider";

const defaultLoadService = () => import("./browserPushService");

export function useBrowserPushLifecycle(loadService = defaultLoadService) {
  const { currentUser, authChecked } = useAppBootstrap();
  const readiness = useAccountReadiness();
  const uid = currentUser?.uid || null;
  useEffect(() => {
    if (!authChecked) return;
    let cancelled = false;
    let cleanup: (() => void) | undefined;
    void loadService().then(service => {
      if (cancelled) return;
      if (!uid) {
        void service.disableBrowserPushBeforeSignOut().catch(() => undefined);
      } else if (readiness.uid === uid && readiness.status === "complete") {
        cleanup = service.observeBrowserPush();
      }
    });
    return () => { cancelled = true; cleanup?.(); };
  }, [uid, authChecked, readiness.uid, readiness.status, loadService]);

}
